/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { fetchDeal, fetchUpdates } from './actions';

const initialState = {
  deal: null,
  updates: null,
  count: 0,
  page: 1,
} as DealDetailsState;

const dealDetails = createSlice({
  name: 'dealdetails',
  initialState,
  reducers: {
    setUpdatesPage(state, action) {
      state.page = action.payload;
    },
    resetDeal(state) {
      state.deal = null;
      state.detailRequestId = undefined;
      state.updatesRequestId = undefined;
      state.updates = null;
      state.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDeal.pending, (state, { meta }) => {
      state.detailRequestId = meta.requestId;
      state.deal = null;
      state.dealError = false;
      state.page = 1;
      state.updates = null;
      state.dealLoading = true;
    });
    builder.addCase(fetchDeal.fulfilled, (state, { payload, meta }) => {
      if (state.detailRequestId !== meta.requestId) {
        return;
      }
      state.deal = payload;
      state.dealError = false;
      state.dealLoading = false;
    });
    builder.addCase(fetchDeal.rejected, (state, { error, meta }) => {
      if (state.detailRequestId !== meta.requestId) {
        return;
      }
      state.deal = null;
      state.dealError = true;
      state.dealLoading = false;
      Sentry.captureException(error);
    });
    builder.addCase(fetchUpdates.pending, (state, { meta }) => {
      state.updatesRequestId = meta.requestId;
      state.updatesError = false;
      state.updatesLoading = true;
    });
    builder.addCase(fetchUpdates.fulfilled, (state, { payload, meta }) => {
      if (state.updatesRequestId !== meta.requestId) {
        return;
      }
      state.updates = payload.results;
      state.count = payload.count;
      state.updatesError = false;
      state.updatesLoading = false;
    });
    builder.addCase(fetchUpdates.rejected, (state, { error, meta }) => {
      if (state.updatesRequestId !== meta.requestId) {
        return;
      }
      state.updatesError = true;
      state.updatesLoading = false;
      Sentry.captureException(error);
    });
  },
});

export const { setUpdatesPage, resetDeal } = dealDetails.actions;

export default dealDetails.reducer;
